import imageSizes from "~/constants/imageSizes"
import type { Definition } from "~/types"

export const PageEmeaLanding: Definition = {
  contentType: 'PageEmeaLanding',
  fields: [
    {
      id: 'headingTitle',
      name: 'Heading Title',
      type: 'Symbol'
    },
    {
      id: 'headingHighlightedTitle',
      name: 'Heading Highlighted Title',
      type: 'Symbol'
    },
    {
      id: 'headingDescription',
      name: 'Heading Description',
      type: 'Text'
    },
    {
      id: 'videos',
      name: 'Videos',
      type: 'Array',
      subType: ['ModuleVideo', 'ModuleInternalVideo', 'ModuleMediaCard']
    },
    {
      id: 'videosMobile',
      name: 'Videos Mobile',
      type: 'Array',
      subType: ['ModuleVideo', 'ModuleInternalVideo', 'ModuleMediaCard']
    },
    {
      id: 'logoBar',
      name: 'Logo bar',
      type: 'BlockLogoBar',
      imageOptions: { recolor: '#d7f5e3' }
    },
    {
      id: 'quotes',
      name: 'Quotes',
      type: 'Array',
      subType: 'BlockQuote'
    },
    {
      id: 'contentBlock1',
      name: 'Content block 1',
      type: 'BlockGroup',
      options: { transformShortDescription: true },
      imageOptions: { resize: true, sizes: imageSizes.columns4_169, lazy: true },
      subType: 'BlockContent'
    },
    // {
    //   id: 'cta',
    //   name: 'Call to action',
    //   type: 'BlockCallToAction'
    // },
    {
      id: 'formMedia',
      name: 'Form Media',
      type: ['ModuleVideo', 'ModuleInternalVideo'],
      imageOptions: { resize: true, sizes: imageSizes.columns6_34, lazy: true }
    },
    {
      id: 'formId',
      name: 'Form ID',
      type: 'Symbol'
    },
    {
      id: 'formTitle',
      name: 'Form Title',
      type: 'Symbol'
    },
    {
      id: 'formDescription',
      name: 'Form Description',
      type: 'Symbol'
    },
    {
      id: 'companiesLabel',
      name: 'Companies Label',
      type: 'Symbol'
    },
    {
      id: 'subscribeLabel',
      name: 'Subscribe Label',
      type: 'Symbol'
    },
    {
      id: 'contactUsLabel',
      name: 'Contact us Label',
      type: 'Symbol'
    },
    {
      id: 'thankYouLabel',
      name: 'Thank you Label',
      type: 'Symbol'
    }
  ]
}

export const PageTeamItaliaLanding: Definition = {
  contentType: 'PageTeamItaliaLanding',
  fields: [
    {
      id: 'heroEyebrow',
      name: 'Hero Eyebrow',
      type: 'Symbol'
    },
    {
      id: 'heroVideo',
      name: 'Hero Video',
      type: ['ModuleVideo', 'ModuleInternalVideo'],
      imageOptions: { resize: true, sizes: imageSizes.columns12_169, lazy: true }
    },
    {
      id: 'contentBlock1',
      name: 'Content Block 1',
      type: 'BlockContent'
    },
    {
      id: 'logoBar',
      name: 'Logo bar',
      type: 'BlockLogoBar'
    },
    {
      id: 'blockUsp1',
      name: 'Block USP 1',
      type: 'BlockUspList'
    },
    {
      id: 'quote',
      name: 'side quote',
      type: 'BlockSimpleQuote'
    },
    {
      id: 'sideQuoteTitle',
      name: 'Side Quote Title',
      type: 'Symbol'
    },
    {
      id: 'sideQuoteDescription',
      name: 'Side Quote Description',
      type: 'Text'
    },
    {
      id: 'sideQuoteLink1',
      name: 'Side Quote Link 1',
      type: 'ModuleNavigationLink'
    },
    {
      id: 'sideQuoteLink1Description',
      name: 'Side Quote Link 1 Description',
      type: 'Symbol'
    },
    {
      id: 'sideQuoteLink2',
      name: 'Side Quote Link 2',
      type: 'ModuleNavigationLink'
    },
    {
      id: 'sideQuoteLink2Description',
      name: 'Side Quote Link 2 Description',
      type: 'Symbol'
    },
    {
      id: 'video',
      name: 'Video',
      type: ['ModuleVideo', 'ModuleInternalVideo'],
      imageOptions: { resize: true, sizes: imageSizes.columns12_169, lazy: true }
    },
    {
      id: 'blockUsp2',
      name: 'Block USP 2',
      type: 'BlockUspList'
    },
    {
      id: 'cta',
      name: 'Call to action',
      type: 'BlockCallToAction'
    },
    {
      id: 'highlightBlock',
      name: 'Highlight Block',
      type: 'BlockHighlight',
      imageOptions: { resize: true, sizes: imageSizes.columns6_43, lazy: true }
    },
    {
      id: 'videosGallery',
      name: 'Videos Gallery',
      type: 'BlockMediaCardGroup',
      imageOptions: { resize: true, sizes: imageSizes.columns4_169, lazy: true }
    },
    {
      id: 'relatedContent',
      name: 'Related content',
      type: 'BlockRelatedContent'
    },
    {
      id: 'form',
      name: 'Form',
      type: 'BlockForm'
    }
  ]
}

export const PageEmeaLanding2025: Definition = {
  contentType: 'PageEmeaLanding2025',
  fields: [
    {
      id: 'headingTitle',
      name: 'Heading Title',
      type: 'Symbol'
    },
    {
      id: 'headingHighlightedTitle',
      name: 'Heading Highlighted Title',
      type: 'Symbol'
    },
    {
      id: 'headingDescription',
      name: 'Heading Description',
      type: 'Symbol'
    },
    {
      id: 'headingLink',
      name: 'Heading Link',
      type: 'ModuleNavigationLink'
    },
    {
      id: 'images',
      name: 'Images',
      type: 'Array',
      subType: 'ModuleMediaCard',
      validations: [{ size: { min: 1, max: 4 } }]
    },
    {
      id: 'imagesMobile',
      name: 'Images Mobile',
      type: 'Array',
      subType: 'ModuleMediaCard',
      validations: [{ size: { min: 1, max: 4 } }]
    },
    {
      id: 'logoBar',
      name: 'Logo bar',
      type: 'BlockLogoBar',
      imageOptions: { recolor: '#d7f5e3' }
    },
    {
      id: 'productFeatureSection',
      name: 'Product Feature Section',
      type: 'Array',
      subType: 'ModuleMediaCard',
      validations: [{ size: { min: 1, max: 3 } }],
      imageOptions: { resize: true, sizes: imageSizes.columns4_169, lazy: true } // update with correct image size
    },
    {
      id: 'quote',
      name: 'Quote',
      type: 'BlockQuote',
      localized: true
    },
    {
      id: 'relatedContentTitle',
      name: 'Related Content Title',
      type: 'Symbol',
      localized: true
    },
    {
      id: 'relatedContent',
      name: 'Related Content',
      type: 'Array',
      options: { transformShortDescription: true },
      imageOptions: { resize: true, sizes: imageSizes.columns4_169, lazy: true },
      subType: 'ModuleMediaCard',
      localized: true,
      validations: [{ size: { min: 1, max: 3 } }]
    },
    {
      id: 'ctaTitle',
      name: 'Call to action title',
      type: 'Symbol',
      localized: true
    },
    {
      id: 'ctaDescription',
      name: 'Call to action description',
      type: 'Symbol',
      localized: true
    },
    {
      id: 'ctaLink',
      name: 'Call to action link',
      type: 'ModuleNavigationLink',
      localized: true
    },
    {
      id: 'contactLink',
      name: 'Navigation link',
      type: 'ModuleNavigationLink',
      localized: true
    }
  ]
}

const PageCampaignsDetailAwareness: Definition = {
  contentType: 'PageCampaignsDetailAwareness',
  fields: [
    {
      id: 'headerSubtitle',
      name: 'Header Subtitle',
      type: 'RichText', // Turn off embed feature in Contentful
      localized: true
    },
    {
      id: 'headerLink',
      name: 'Header Link',
      type: 'ModuleNavigationLink'
    },
    {
      id: 'secondaryHeaderLink',
      name: 'Secondary Header Link',
      type: 'ModuleNavigationLink'
    },
    {
      id: 'headerImage',
      name: 'Mobile Header Media',
      type: ['ModuleMedia', 'ModuleInternalVideo'],
      imageOptions: [
        // Vertical
        {
          resize: true,
          // this is portrait
          sizes: imageSizes.hero
        },
        // Horizontal
        {
          resize: true,
          sizes: imageSizes.hero
        },
        // Animated Hero
        {
          resize: true,
          sizes: imageSizes.hero
        }
      ]
    },
    {
      id: 'fpZoom',
      name: 'Mobile Header Zoom',
      type: 'Integer'
    },
    {
      id: 'desktopHeaderImage',
      name: 'Desktop Header Media',
      type: ['ModuleMedia', 'ModuleInternalVideo'],
      imageOptions: [
        // Vertical
        {
          resize: true,
          sizes: imageSizes.hero
        },
        // Horizontal
        {
          resize: true,
          sizes: imageSizes.hero
        },
        {
          resize: true,
          sizes: imageSizes.hero
        }
      ]
    },
    {
      id: 'fpZoomDesktop',
      name: 'Desktop Header Zoom',
      type: 'Integer'
    },
    {
      id: 'headerEyebrow',
      name: 'Header Eyebrow',
      type: 'Text',
      localized: true
    },
    {
      id: 'heroTheme',
      name: 'Hero Theme',
      type: 'GlobalDataTheme'
    },
    {
      id: 'headerLandscapeImage',
      name: 'Header Landscape image',
      type: 'Boolean'
    },
    {
      id: 'hasAnimatedHero',
      name: 'Do you want to use the Animated Hero?',
      type: 'Boolean'
    },
    {
      id: 'formAnchorLabel',
      name: 'Form Anchor Label',
      type: 'Symbol'
    },
    {
      id: 'contentBlocks',
      name: 'Content Blocks',
      type: 'Array',
      subType: ['BlockLandscapeMediaThenContent', 'BlockContentCenteredTextOnly', 'BlockCampaignsMetrics', 'BlockCampaignsMedia', 'BlockLandingUspList', 'BlockSimpleQuote', 'BlockCampaignsCards', 'BlockLogoBar', 'BlockLandingLogoBar', 'BlockCampaignsCallOut', 'BlockQuoteGroup'],
      validations: [{ size: { min: 0, max: 8 } }],
      lazy: true
    },
    {
      id: 'callToAction',
      name: 'Call to action',
      type: 'BlockCampaignsCallToAction',
      // required: true
    },
    {
      id: 'relatedContent',
      name: 'Related content',
      type: 'BlockRelatedContent'
    }
  ]
}

const LandingDefinitions = {
  PageEmeaLanding,
  PageEmeaLanding2025,
  PageTeamItaliaLanding,
  PageCampaignsDetailAwareness
}

export default LandingDefinitions